import type {StaffTaskRow} from '@myfm/contracts';
import {Link} from '../ui/ScopedLink';
import {ResponsiveTable} from '../ui/ResponsiveTable';
import {StatusBadge} from '../ui/StatusBadge';
import {formatDateOnly,formatDateTime} from '../dates';
import {taskRowElementId} from '../ui/task-navigation';
import {taskSourceLabels,taskStatusBadge} from './task-presentation';

/** Presentation only: assignments, dates and destinations remain source-owned. */
export function AssignedTaskTable({items,href,search,rememberRow}:{items:readonly StaffTaskRow[];href:string;search:string;rememberRow:(key:string)=>void}){
 return <ResponsiveTable className="data-table assigned-task-table"><caption className="sr-only">Assigned tasks</caption>
  <thead><tr>{['Task','Building','Owner','Due','Status','Details'].map(label=><th scope="col" key={label}>{label}</th>)}</tr></thead>
  <tbody>{items.map(item=><tr key={item.key}>
   <th scope="row">{item.href?<Link id={taskRowElementId(item.key)} to={item.href} state={{taskReturn:{to:href,search,focusKey:item.key}}} onClick={()=>rememberRow(item.key)}>{item.title}</Link>:<span id={taskRowElementId(item.key)} tabIndex={-1}>{item.title}</span>}</th>
   <td>{item.building?.name??'No building recorded'}</td>
   <td><span className="sr-only">Assigned to </span>{item.assignee.name}</td>
   <td>{item.due?<time dateTime={item.due.value} title={item.due.label}>{item.due.kind==='date'?formatDateOnly(item.due.value.slice(0,10)):formatDateTime(item.due.value)}</time>:'No date recorded'}</td>
   <td><StatusBadge {...taskStatusBadge(item)}/></td>
   <td><details className="task-row-details"><summary>{item.blockers.length?'Recorded blockers':'Task details'}</summary><p>{taskSourceLabels[item.source]} · {item.reference}</p><p>{item.attentionReason}</p>
    {!!item.blockers.length&&<ul>{item.blockers.map(blocker=><li key={blocker}>{blocker}</li>)}</ul>}
    <p>{item.href?`Next: ${item.actionLabel}`:'Record destination unavailable.'}</p>
    {item.priority&&<p>Source priority: {item.priority}</p>}{item.risk&&<p>Source risk: {item.risk}</p>}
   </details></td>
  </tr>)}</tbody>
 </ResponsiveTable>;
}
